import { useEffect } from 'react';
import Cookies from 'universal-cookie';

import { Condition } from 'Component/others';
import useGetMonitoringStatus from 'Domain/monitoring/useGetMonitoringStatus';
import { getMenuPermissions } from 'Helper/getMenuPermissions';

import checkIsChangeDevice from 'View/monitoring/helper/checkIsChangeDevice';
import Camera from 'View/monitoring/section/camera';
import ChangeDeviceModal from 'View/monitoring/component/change-device';
import useMonitoringState from 'View/monitoring/state';
import getSelectedViewByStatus from 'View/monitoring/helper/getSelectedViewByStatus';
import Ping from 'View/monitoring/component/ping';
import BreakModal from 'View/monitoring/component/break-modal';
import Captcha from 'View/monitoring/section/captcha';

const MonitoringOperator = () => {
  const cookies = new Cookies();
  const token = cookies.get('token');
  const monitoringPermissions = getMenuPermissions('main-dashboard', 'monitoring-operator');
  const isCanMonitoring = monitoringPermissions?.isCanRead;

  const { selectedView, updateState } = useMonitoringState();
  const { data: monitoringStatus, refetch, isFetching } = useGetMonitoringStatus({ isEnabled: isCanMonitoring });

  const isOpenChangeDeviceModal = checkIsChangeDevice(monitoringStatus, selectedView);
  const isShowFaceDetection = selectedView === 'clock-in' && !isOpenChangeDeviceModal;
  const isBreak = selectedView?.includes('break');
  const isShowWidget = Boolean(token) && monitoringStatus && isCanMonitoring;

  useEffect(() => {
    const selectedViewByStatus = getSelectedViewByStatus(monitoringStatus);

    if (monitoringStatus) updateState({ selectedView: selectedViewByStatus, monitoringStatus });

    /* eslint-disable */
  }, [monitoringStatus]);

  useEffect(() => {
    if (monitoringStatus?.status === 'ON_BREAK') document.addEventListener('visibilitychange', refetch);
    else return () => document.removeEventListener('visibilitychange', refetch);

    return () => document.removeEventListener('visibilitychange', refetch);
  }, [monitoringStatus]);

  return (
    <Condition statement={isShowWidget}>
      <Ping monitoringStatus={monitoringStatus} isOpenChangeDeviceModal={isOpenChangeDeviceModal} />
      <Condition statement={isShowFaceDetection} children={<Camera monitoringStatus={monitoringStatus} />} />
      <Captcha monitoringStatus={monitoringStatus} />
      <Condition statement={isOpenChangeDeviceModal} children={<ChangeDeviceModal monitoringStatus={monitoringStatus} />} />
      <Condition statement={isBreak} children={<BreakModal monitoringStatus={monitoringStatus} isFetching={isFetching} />} />
    </Condition>
  );
};

export default MonitoringOperator;
